import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { DrFileMeta, FileUploadStatus } from '../../models/dr-file';
import { ComponentServiceBundle } from '../../../core/services/base/component-service-bundle.service';
import { FileListBaseComponent } from './file-list-base.component';
import { HasId } from '@app/shared/models/base';

@Directive()
export abstract class FileSelectionListBaseComponent extends FileListBaseComponent {

    @Input()
    public selected?: HasId[];

    @Output()
    public select = new EventEmitter<DrFileMeta>();

    protected constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
    }

    public selectFile(file: DrFileMeta): void {
        if (!this.disabled && file.status === FileUploadStatus.READY && !file.not_selectable) {
            this.select.emit(file);
        }
    }

    public isSelected(id: string): boolean {
        return this.selected && !!this.selected.find(fileMeta => fileMeta.id === id);
    }
}
